<script>
  import { onDestroy } from "svelte"
  import BadgeState from "../../Stores/badgeState"

  let index = 0

  let currentMessage

  const FOOTER_LIST = {
    GENERAL: ["You can change the background color in settings", "Add or Edit, Text, shapes, ribbons and images", "You can Add custom fonts for text layers", "You can Able to change badge template name", "Able to Download the Badge"],
    TEXT: ["Modify the layer Title as needed.", "Choose from various font families.", "Select any color of your choice.", "Customize font styles to match your preference.", "Easily move and reposition the text."],
    SHAPE: ["You can modify the layer Title.", "Adjust the size of the shape.", "Move and drag the shape easily.", "Change the X and Y positions as needed.", "Shapes can also be modified."],
    RIBBON: ["You can modify the layer Title.", "Adjust the size of the ribbon.", "Move and drag the ribbon easily.", "Change the X and Y positions as needed.", "Ribbons can also be modified."],
    IMAGE: ["You can modify the layer Title.", "Adjust the size of the image.", "Move and drag the image easily.", "Change the X and Y positions as needed.", "Image can also be modified."],
  }

  let timer = setInterval(() => {
    let currentArray = FOOTER_LIST[$BadgeState.footer] || FOOTER_LIST.GENERAL
    if (index < currentArray.length) {
      currentMessage = currentArray[index]
      index++
    } else {
      index = 0
    }
  }, 3000)

  onDestroy(() => {
    clearInterval(timer)
  })
</script>

<div class="flex w-full items-center justify-between bg-[#000000cc] py-2 pr-6 pl-24">
  <div class="flex items-center justify-between gap-9">
    <div class=" flex items-center gap-3 text-xs text-gray-500 md:text-base">
      <i class="fa-solid fa-square-dashed" />
      <h1 class="select-none text-sm font-bold tracking-wide text-gray-500 lg:text-base">{$BadgeState.baseInfo.width || 0} X {$BadgeState.baseInfo.height || 0} px</h1>
    </div>
    <div class="flex w-32 items-center gap-3 text-xs text-gray-500 md:text-base">
      <i class="fa-solid fa-arrow-pointer" />
      <div>
        <h1 class="select-none text-sm font-bold tracking-wide text-gray-500 lg:text-base">{Math.floor($BadgeState.cursorPosition.x)}, {Math.floor($BadgeState.cursorPosition.y)}</h1>
      </div>
    </div>
    <div class=" flex items-center gap-3">
      <h1 class="select-none text-sm font-bold tracking-wide text-gray-500 lg:text-base">{Math.round($BadgeState.scale * 100)}%</h1>
      <button
        on:click={() => {
          if ($BadgeState.scale > 1) {
            $BadgeState.scale = $BadgeState.scale - 0.1
          }
        }}
      >
        <i class="fa-solid fa-minus text-gray-500" />
      </button>
      <input min="1" max="2.5" step="0.1" bind:value={$BadgeState.scale} type="range" class="cursor-pointer outline-none" />
      <button
        on:click={() => {
          if ($BadgeState.scale < 2.5) {
            $BadgeState.scale = $BadgeState.scale + 0.1
          }
        }}
      >
        <i class="fa-solid fa-plus text-gray-500" />
      </button>
    </div>
  </div>
  <h1 class="block text-xs font-bold tracking-wide text-gray-500 md:text-base">
    {currentMessage || "Badge Template Editor.!!!"}
  </h1>
</div>
